

export function convertNameToPostId(title: string) {
    return title.toLowerCase().replace(/\s/g, '-').replace(/[^a-zA-Z0-9-]/g, '')

}